import type { Corner } from '../../utils';

/** Structural, for the same reason as `SpacingLike`. */
export type CornersLike = { value?: Partial<Record<Corner, number>>; unit?: string };
import { CORNERS } from '../../utils';

/** One corner, `0px` when unset. */
export function cornerVar(corners: CornersLike | null | undefined, corner: Corner): string {
    return `${corners?.value?.[corner] ?? 0}${corners?.unit ?? 'px'}`;
}

/** The `top-left top-right bottom-right bottom-left` shorthand, or `undefined` when there are no corners. */
export function cornersShorthandVar(corners: CornersLike | null | undefined): string | undefined {
    return corners ? CORNERS.map((corner) => cornerVar(corners, corner)).join(' ') : undefined;
}
